"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.track = void 0;
const operationTracking_1 = require("./operationTracking");
const EngageStats_1 = require("./EngageStats");
const EngageLogger_1 = require("./EngageLogger");
const IntegrationErrorWrapper_1 = require("./IntegrationErrorWrapper");
exports.track = operationTracking_1.OperationDecorator.createDecoratorFactoryWithDefault(EngageLogger_1.EngageLogger, EngageStats_1.EngageStats, IntegrationErrorWrapper_1.IntegrationErrorWrapper);
//# sourceMappingURL=track.js.map